"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectableObservableDescriptor = exports.ConnectableObservable = void 0;

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Subject = require("../Subject");

var _Observable2 = require("../Observable");

var _Subscriber2 = require("../Subscriber");

var _Subscription = require("../Subscription");

var _refCount = require("../operators/refCount");

/**
 * @class ConnectableObservable<T>
 */
var ConnectableObservable =
/*#__PURE__*/
function (_Observable) {
  (0, _inherits2.default)(ConnectableObservable, _Observable);

  function ConnectableObservable(source, subjectFactory) {
    var _this;

    (0, _classCallCheck2.default)(this, ConnectableObservable);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ConnectableObservable).call(this));
    _this.source = source;
    _this.subjectFactory = subjectFactory;
    _this._refCount = 0;
    _this._isComplete = false;
    return _this;
  }

  (0, _createClass2.default)(ConnectableObservable, [{
    key: "_subscribe",
    value: function _subscribe(subscriber) {
      return this.getSubject().subscribe(subscriber);
    }
  }, {
    key: "getSubject",
    value: function getSubject() {
      var subject = this._subject;

      if (!subject || subject.isStopped) {
        this._subject = this.subjectFactory();
      }

      return this._subject;
    }
  }, {
    key: "connect",
    value: function connect() {
      var connection = this._connection;

      if (!connection) {
        this._isComplete = false;
        connection = this._connection = new _Subscription.Subscription();
        connection.add(this.source.subscribe(new ConnectableSubscriber(this.getSubject(), this)));

        if (connection.closed) {
          this._connection = null;
          connection = _Subscription.Subscription.EMPTY;
        } else {
          this._connection = connection;
        }
      }

      return connection;
    }
  }, {
    key: "refCount",
    value: function refCount() {
      return (0, _refCount.refCount)()(this);
    }
  }]);
  return ConnectableObservable;
}(_Observable2.Observable);

exports.ConnectableObservable = ConnectableObservable;
var connectableProto = ConnectableObservable.prototype;
var connectableObservableDescriptor = {
  operator: {
    value: null
  },
  _refCount: {
    value: 0,
    writable: true
  },
  _subject: {
    value: null,
    writable: true
  },
  _connection: {
    value: null,
    writable: true
  },
  _subscribe: {
    value: connectableProto._subscribe
  },
  _isComplete: {
    value: connectableProto._isComplete,
    writable: true
  },
  getSubject: {
    value: connectableProto.getSubject
  },
  connect: {
    value: connectableProto.connect
  },
  refCount: {
    value: connectableProto.refCount
  }
};
exports.connectableObservableDescriptor = connectableObservableDescriptor;

var ConnectableSubscriber =
/*#__PURE__*/
function (_SubjectSubscriber) {
  (0, _inherits2.default)(ConnectableSubscriber, _SubjectSubscriber);

  function ConnectableSubscriber(destination, connectable) {
    var _this2;

    (0, _classCallCheck2.default)(this, ConnectableSubscriber);
    _this2 = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ConnectableSubscriber).call(this, destination));
    _this2.connectable = connectable;
    return _this2;
  }

  (0, _createClass2.default)(ConnectableSubscriber, [{
    key: "_error",
    value: function _error(err) {
      this._unsubscribe();

      (0, _get2.default)((0, _getPrototypeOf2.default)(ConnectableSubscriber.prototype), "_error", this).call(this, err);
    }
  }, {
    key: "_complete",
    value: function _complete() {
      this.connectable._isComplete = true;

      this._unsubscribe();

      (0, _get2.default)((0, _getPrototypeOf2.default)(ConnectableSubscriber.prototype), "_complete", this).call(this);
    }
  }, {
    key: "_unsubscribe",
    value: function _unsubscribe() {
      var connectable = this.connectable;

      if (connectable) {
        this.connectable = null;
        var connection = connectable._connection;
        connectable._refCount = 0;
        connectable._subject = null;
        connectable._connection = null;

        if (connection) {
          connection.unsubscribe();
        }
      }
    }
  }]);
  return ConnectableSubscriber;
}(_Subject.SubjectSubscriber);

var RefCountOperator =
/*#__PURE__*/
function () {
  function RefCountOperator(connectable) {
    (0, _classCallCheck2.default)(this, RefCountOperator);
    this.connectable = connectable;
  }

  (0, _createClass2.default)(RefCountOperator, [{
    key: "call",
    value: function call(subscriber, source) {
      var connectable = this.connectable;
      connectable._refCount++;
      var refCounter = new RefCountSubscriber(subscriber, connectable);
      var subscription = source.subscribe(refCounter);

      if (!refCounter.closed) {
        refCounter.connection = connectable.connect();
      }

      return subscription;
    }
  }]);
  return RefCountOperator;
}();

var RefCountSubscriber =
/*#__PURE__*/
function (_Subscriber) {
  (0, _inherits2.default)(RefCountSubscriber, _Subscriber);

  function RefCountSubscriber(destination, connectable) {
    var _this3;

    (0, _classCallCheck2.default)(this, RefCountSubscriber);
    _this3 = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RefCountSubscriber).call(this, destination));
    _this3.connectable = connectable;
    return _this3;
  }

  (0, _createClass2.default)(RefCountSubscriber, [{
    key: "_unsubscribe",
    value: function _unsubscribe() {
      var connectable = this.connectable;

      if (!connectable) {
        this.connection = null;
        return;
      }

      this.connectable = null;
      var refCount = connectable._refCount;

      if (refCount <= 0) {
        this.connection = null;
        return;
      }

      connectable._refCount = refCount - 1;

      if (refCount > 1) {
        this.connection = null;
        return;
      } ///
      // Compare the local RefCountSubscriber's connection Subscription to the
      // connection Subscription on the shared ConnectableObservable. In cases
      // where the ConnectableObservable source synchronously emits values, and
      // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
      // execution continues to here before the RefCountOperator has a chance to
      // supply the RefCountSubscriber with the shared connection Subscription.
      // For example:
      // ```
      // Observable.range(0, 10)
      //   .publish()
      //   .refCount()
      //   .take(5)
      //   .subscribe();
      // ```
      // In order to account for this case, RefCountSubscriber should only dispose
      // the ConnectableObservable's shared connection Subscription if the
      // connection Subscription exists, *and* either:
      //   a. RefCountSubscriber doesn't have a reference to the shared connection
      //      Subscription yet, or,
      //   b. RefCountSubscriber's connection Subscription reference is identical
      //      to the shared connection Subscription
      ///


      var connection = this.connection;
      var sharedConnection = connectable._connection;
      this.connection = null;

      if (sharedConnection && (!connection || sharedConnection === connection)) {
        sharedConnection.unsubscribe();
      }
    }
  }]);
  return RefCountSubscriber;
}(_Subscriber2.Subscriber);